import { useCallback } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useMaterialUIController, setMiniSidenav, setMobileSidenavOpen } from "app/providers";
import { SIDENAV_BREAKPOINT } from "./constants";

export default function useSidenav() {
  const [controller, dispatch] = useMaterialUIController();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up(SIDENAV_BREAKPOINT));
  const toggle = () => {
    if (isDesktop) setMiniSidenav(dispatch, !controller.miniSidenav);
    else setMobileSidenavOpen(dispatch, !controller.mobileSidenavOpen);
  };
  const closeMobile = useCallback(() => setMobileSidenavOpen(dispatch, false), [dispatch]);
  return {
    isDesktop,
    isMini: isDesktop && controller.miniSidenav,
    mobileOpen: controller.mobileSidenavOpen,
    toggle,
    closeMobile,
  };
}
